module.exports = __webpack_public_path__ + "img/404.627f8f6e.svg";